import { ArrowRightLeft, Home, ChartPie, Search } from 'lucide-react';
import { Sidebar, SidebarContent, SidebarFooter, SidebarGroup, SidebarGroupContent, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarTrigger } from '@/components/ui/sidebar';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { cn } from '@/lib/misc/utils';
import Link from 'next/link';
import { RiDiscordFill, RiTelegramFill, RiTwitterXFill } from 'react-icons/ri';
import DegenModeSwitchModal from './modal/DegenModeSwitchModal';
import MobileAppModal from './modal/MobileAppModal';
import { useSwap } from '@/contexts/SwapProvider';

// Menu items.
const items = [{
  title: 'Home',
  url: '/home',
  icon: Home
}, {
  title: 'Portfolio',
  url: '/portfolio',
  icon: ChartPie
}, {
  title: 'Swap',
  url: '/trade',
  icon: ArrowRightLeft
}];
export function AppSidebar() {
  const router = useRouter();
  const {
    resetAssets
  } = useSwap();
  return <div className='w-[15%] bg-genius-indigo genius-shadow z-[1000]' data-sentry-component="AppSidebar" data-sentry-source-file="AppSidebar.tsx">
      <Sidebar className='border-genius-blue border-r-[1px] ' data-sentry-element="Sidebar" data-sentry-source-file="AppSidebar.tsx">
        <SidebarHeader className='bg-genius-indigo' data-sentry-element="SidebarHeader" data-sentry-source-file="AppSidebar.tsx">
          <SidebarMenu data-sentry-element="SidebarMenu" data-sentry-source-file="AppSidebar.tsx">
            <SidebarMenuItem className='py-4 grid gap-4 justify-items-center' data-sentry-element="SidebarMenuItem" data-sentry-source-file="AppSidebar.tsx">
              <Image src='/static/genius.png' width={100} height={100} alt='genius-logo' className='w-[30px] h-[30px]' data-sentry-element="Image" data-sentry-source-file="AppSidebar.tsx" />
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarHeader>

        <SidebarContent className='bg-genius-indigo' data-sentry-element="SidebarContent" data-sentry-source-file="AppSidebar.tsx">
          <SidebarGroup data-sentry-element="SidebarGroup" data-sentry-source-file="AppSidebar.tsx">
            <SidebarGroupContent className='p-0' data-sentry-element="SidebarGroupContent" data-sentry-source-file="AppSidebar.tsx">
              <SidebarMenu className='items-center w-full' data-sentry-element="SidebarMenu" data-sentry-source-file="AppSidebar.tsx">
                {items.map(item => <SidebarMenuItem key={item.title} className='w-full'>
                    <SidebarMenuButton asChild className={cn('w-full h-[38px] p-[12px] rounded-lg hover:bg-genius-blue active:bg-genius-blue', router.pathname === item.url ? 'bg-genius-pink text-black' : '')}>
                      <Link href={item.url} onClick={() => resetAssets()}>
                        <item.icon />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>)}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        </SidebarContent>

        <SidebarFooter className='bg-genius-indigo' data-sentry-element="SidebarFooter" data-sentry-source-file="AppSidebar.tsx">
          <SidebarMenu className='grid gap-4 justify-center' data-sentry-element="SidebarMenu" data-sentry-source-file="AppSidebar.tsx">
            <SidebarMenuItem data-sentry-element="SidebarMenuItem" data-sentry-source-file="AppSidebar.tsx">
              <MobileAppModal data-sentry-element="MobileAppModal" data-sentry-source-file="AppSidebar.tsx" />
            </SidebarMenuItem>
            <SidebarMenuItem data-sentry-element="SidebarMenuItem" data-sentry-source-file="AppSidebar.tsx">
              <DegenModeSwitchModal data-sentry-element="DegenModeSwitchModal" data-sentry-source-file="AppSidebar.tsx" />
            </SidebarMenuItem>
            <SidebarMenuItem data-sentry-element="SidebarMenuItem" data-sentry-source-file="AppSidebar.tsx">
              <div className='social flex justify-between items-center py-4 gap-x-5 text-genius-pink'>
                <Link target='_blank' href='https://x.com/GeniusTerminal' aria-label='GeniusTerminal on X' data-sentry-element="Link" data-sentry-source-file="AppSidebar.tsx">
                  <RiTwitterXFill className='cursor-pointer' size={20} data-sentry-element="RiTwitterXFill" data-sentry-source-file="AppSidebar.tsx" />
                </Link>
                <Link target='_blank' href={'https://discord.com/invite/geniusterminal'} aria-label='GeniusTerminal on Discord' data-sentry-element="Link" data-sentry-source-file="AppSidebar.tsx">
                  <RiDiscordFill className='cursor-pointer' size={20} data-sentry-element="RiDiscordFill" data-sentry-source-file="AppSidebar.tsx" />
                </Link>
                <Link target='_blank' href='https://t.me/geniusverification' aria-label='GeniusTerminal on Telegram' data-sentry-element="Link" data-sentry-source-file="AppSidebar.tsx">
                  <RiTelegramFill className='cursor-pointer' size={20} data-sentry-element="RiTelegramFill" data-sentry-source-file="AppSidebar.tsx" />
                </Link>
              </div>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarFooter>
      </Sidebar>
    </div>;
}